var map = {
	"./arrow_down.svg": "34dc",
	"./arrow_down_1.svg": "f169",
	"./arrow_down_2.svg": "968b",
	"./arrow_down_left_right.svg": "5616",
	"./arrow_right.svg": "5c16",
	"./bg-transition.svg": "e03a",
	"./call_accept.svg": "56fb",
	"./call_flow_type_all.svg": "bed8",
	"./call_flow_type_no_working.svg": "e0dd",
	"./call_flow_type_working.svg": "027b",
	"./call_hold_active.svg": "55bf",
	"./call_menu.svg": "a04a",
	"./call_menu_title.svg": "b108",
	"./card.svg": "3522",
	"./contact.svg": "2e1d",
	"./delete.svg": "2c46",
	"./delete4.svg": "9c0b",
	"./demo-calling.svg": "6d0c",
	"./demo-team.svg": "dbad",
	"./demo-texting.svg": "0668",
	"./detail - Copy.svg": "a80a",
	"./detail.svg": "7fdc",
	"./dropdown.svg": "a880",
	"./edit.svg": "b0e3",
	"./edit_white.svg": "94ef",
	"./go.svg": "6a2a",
	"./group_white.svg": "0919",
	"./hang_up.svg": "6f04",
	"./info.svg": "db39",
	"./laptop.svg": "13a1",
	"./line_down2.svg": "68c5",
	"./local.svg": "4ceb",
	"./logo.svg": "e347",
	"./logo_black.svg": "5959",
	"./menu.svg": "c8fa",
	"./next.svg": "35fe",
	"./noassign_white.svg": "abdc",
	"./note.svg": "850a",
	"./padlock.svg": "8457",
	"./paypal.svg": "b67a",
	"./person_white.svg": "58f3",
	"./play.svg": "53e0",
	"./port.svg": "7d99",
	"./record.svg": "13f2",
	"./recording_created.svg": "e381",
	"./recording_needed.svg": "19e2",
	"./recording_title.svg": "8321",
	"./route.svg": "b1fd",
	"./route_recording_disable.svg": "4a92",
	"./route_recording_enable.svg": "dd6d",
	"./routing_created.svg": "d412",
	"./routing_disabled.svg": "2e96",
	"./routing_needed.svg": "1edc",
	"./stop.svg": "f955",
	"./stop1.svg": "92af",
	"./stop_green.svg": "25f1",
	"./toll-free.svg": "9925",
	"./upload.svg": "ad34",
	"./voice_mail_3.svg": "a647",
	"./voicemail.svg": "c223",
	"./voicemail1.svg": "5022",
	"./voyyp.svg": "a9ac",
	"./voyyp1.svg": "95f4",
	"./welcome.svg": "5750"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c6e";